import { render, staticRenderFns } from "./purchase_hangqing.vue?vue&type=template&id=085c6773&scoped=true"
import script from "./purchase_hangqing.vue?vue&type=script&lang=js"
export * from "./purchase_hangqing.vue?vue&type=script&lang=js"
import style0 from "./purchase_hangqing.vue?vue&type=style&index=0&id=085c6773&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "085c6773",
  null
  
)

export default component.exports